export default __webpack_public_path__ + "static/media/second_order.96eb61e9.svg";